import { render, staticRenderFns } from "./SplitContainer21.vue?vue&type=template&id=7764fede"
import script from "./SplitContainer21.vue?vue&type=script&lang=js"
export * from "./SplitContainer21.vue?vue&type=script&lang=js"
import style0 from "./SplitContainer21.vue?vue&type=style&index=0&id=7764fede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports